import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input
} from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { SolutionMenuItem } from "../../../../core/models/products.model";
import { ProductService } from "../../../../core/services/products.service";
import { SiilaTranslationService } from "../../../../core/services/siila-translation.service";
import { I18nService } from "../../../services";

@Component({
  selector: "app-solution-list",
  templateUrl: "./solution-list.component.html",
  styleUrls: ["./solution-list.component.scss"]
})
export class SolutionListComponent implements OnInit {
  @Input() val: number = 0;
  solutions: SolutionMenuItem[];
  currentCode: string;
  isMobile = false;
  constructor(
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
    public breakpointObserver: BreakpointObserver,
    private i18n: I18nService,
    private siilaTranslationService: SiilaTranslationService
  ) {
    this.currentCode = environment.platformId;
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  ngOnInit(): void {
    this.productService.getSolutionList().subscribe(solutions => {
      this.solutions = solutions;
      this.cdr.markForCheck();
    });
  }

  /**
   * Open a solution at its canonical URL for the ACTIVE language.
   *
   * The slug is derived from the record's own `solutionName`, exactly as the
   * header (`menu.component.html`) and footer (`getSolutionUrl`) already do.
   * This used to dispatch on id to one of seven methods that each hardcoded an
   * ENGLISH slug, so every Spanish click built `/solutions/<id>/<english-slug>
   * /lang/es` and two of the hardcoded English slugs were stale as well
   * (`operators-&-developers` for `owners,-operators-&-developers`, `tenants`
   * for `tenants-&-corporate-occupiers`). The route reads only `:id`, so the
   * page still resolved and `UrlCanonicalService` then corrected the address
   * bar — which is why it looked like "an English URL first".
   *
   * Deriving the slug also drops the id whitelist: a solution whose id was not
   * in the dispatch did nothing at all on click.
   */
  openServe(solution: SolutionMenuItem) {
    if (!solution) {
      return;
    }

    window.open(
      `${
        environment.applicationURL
      }${this.siilaTranslationService.buildSolutionDetailUrl(
        solution.solutionName,
        solution.id
      )}`,
      this.isMobile || this.val == 1 ? "_self" : "_blank"
    );
  }

  openAllProducts() {
    window.open(
      this.i18n.buildLocalizedPath(`${environment.applicationURL}/products`),
      this.isMobile || this.val == 1 ? "_self" : "_blank"
    );
  }
}
